import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import ShippingAnnouncementBar from './ShippingAnnouncementBar';
import WhatsAppChat from '../whatsapp/WhatsAppChat';

const Layout = ({ children }) => {
  const location = useLocation();

  // Check if current route is the configurator page
  const isConfiguratorPage = location.pathname === '/configurator';
  
  // Check if current route is login or register page
  const isAuthPage = location.pathname === '/login' || location.pathname === '/register' || location.pathname === '/forgot-password';

  // Scroll to top on page change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  // If we're on the auth pages, render with header but without footer
  if (isAuthPage) {
    return (
      <div className="min-h-screen bg-white">
        <ShippingAnnouncementBar />
        <Header />
        <main>{children}</main>
        <WhatsAppChat />
      </div>
    );
  }

  // If we're on the configurator page, render without footer
  if (isConfiguratorPage) {
    return (
      <div className="min-h-screen bg-white">
        <ShippingAnnouncementBar />
        <Header />
        <main>{children}</main>
        <WhatsAppChat />
      </div>
    );
  }

  // Otherwise, render normal layout with header and footer
  return (
    <div className="flex flex-col min-h-screen bg-grad">
      <ShippingAnnouncementBar />
      <Header />
      <main className="flex-grow">
        {children}
      </main>
      <Footer />
      <WhatsAppChat />
    </div>
  );
};

export default Layout;

